import { useState, useEffect } from 'react';
import { getServices } from '../services/api';
import ServiceCard from '../components/ServiceCard';
import { profileServices } from '../content/companyContent';
import './Services.css';

function Services() {
  const [services, setServices] = useState(profileServices);
  const [filteredServices, setFilteredServices] = useState(profileServices);
  const [selectedType, setSelectedType] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices();
  }, []);

  const fetchServices = async () => {
    try {
      const response = await getServices();
      const data = response.data.results || response.data;
      const serviceData = data.length ? data : profileServices;
      setServices(serviceData);
      setFilteredServices(serviceData);
    } catch (error) {
      console.error('Error fetching services:', error);
      setServices(profileServices);
      setFilteredServices(profileServices);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (type) => {
    setSelectedType(type);
    if (type === 'all') {
      setFilteredServices(services);
    } else {
      setFilteredServices(services.filter(s => s.service_type === type));
    }
  };

  const serviceTypes = [
    { value: 'all', label: 'All Services' },
    { value: 'pathology', label: 'Pathology' },
    { value: 'ambulance', label: 'Ambulance' },
    { value: 'tpa', label: 'TPA & Empanelment' },
    { value: 'consultation', label: 'Doctor Consultation' },
    { value: 'health_tech', label: 'Health Tech' },
    { value: 'it', label: 'IT Services' },
    { value: 'management', label: 'Hospital Management' },
    { value: 'courier', label: 'Courier & Logistics' },
    { value: 'tourism', label: 'Medical Tourism' },
  ];

  return (
    <div className="services-page">
      <div className="services-hero">
        <h1>Integrated Healthcare Services</h1>
        <p>Diagnostics, emergency response, logistics, health-tech, and hospital support.</p>
      </div>

      <div className="services-container">
        <div className="filters">
          <h3>Filter by Type</h3>
          {serviceTypes.map(type => (
            <button
              key={type.value}
              className={`filter-btn ${selectedType === type.value ? 'active' : ''}`}
              onClick={() => handleFilter(type.value)}
            >
              {type.label}
            </button>
          ))}
        </div>

        <div className="services-content">
          {loading ? (
            <p className="loading">Loading services...</p>
          ) : filteredServices.length > 0 ? (
            <div className="services-grid">
              {filteredServices.map(service => (
                <ServiceCard key={service.id} service={service} />
              ))}
            </div>
          ) : (
            <p className="no-data">No services found in this category.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Services;
